/*
 * Architare Handschrift — Verhalten (Stand 26.08.2026, v2 INLINE).
 * Quelle: architare-hq/scripts/theme-src/assets/architare-handschrift.js
 *
 * Antons Vorgabe (Produktvision 19.08.): die Buehne oeffnet sich INLINE ueber der
 * Produkt-Sektion — Menue bleibt stehen, die Sektion wird Nacht, das Produkt steht
 * links als Anker, die Partikel schwaermen aus dem Anker zu den Rollen-Karten rechts
 * (Brain-Konstellation, Physik aus handschrift-start-prototyp.html; Statuszeilen und
 * drei Akte aus handschrift-prototyp.html).
 *
 * 1. Consent-Gate: Zuweisung/Messung nur, wenn Shopify.customerPrivacy Analytics erlaubt.
 *    Ohne Consent: Variante a, nichts gespeichert, nichts gesendet. ?hs=a|b erzwingt.
 * 2. A/B sticky (localStorage architare_hs_variante/_test); b = Trigger sichtbar,
 *    "Dazu passt" versteckt (html.hs-b). modus alle/aus schaltet den Test ab.
 * 3. Messung: sendBeacon an /api/shop/ab (nur Handles/Rollen/Positionen, anonyme
 *    Sitzungs-ID) + Clarity/gtag. ATC: Impact feuert document 'cart:change' mit
 *    detail.baseEvent 'variant:add'. Keine internen Kennzahlen, keine Kundendaten.
 */
(function () {
  if (window.__architareHsLoaded) return;
  window.__architareHsLoaded = true;

  var root = document.querySelector('[data-hs]');
  if (!root) return;
  var cfg;
  try { cfg = JSON.parse(root.getAttribute('data-hs-config')); } catch (e) { return; }
  var hatModul = root.getAttribute('data-hs-modul') === 'ja';
  var handle = root.getAttribute('data-hs-handle') || '';
  var ruhig = false;
  try { ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var geraet = 'desktop';
  try { geraet = window.matchMedia('(max-width: 899px)').matches ? 'mobil' : 'desktop'; } catch (e) {}

  // ---------------------------------------------------------------- Speicher
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function hex16() {
    var out = '', a = new Uint8Array(8);
    try { crypto.getRandomValues(a); } catch (e) { for (var i = 0; i < 8; i++) a[i] = Math.random() * 256 | 0; }
    for (var j = 0; j < 8; j++) out += ('0' + a[j].toString(16)).slice(-2);
    return out;
  }

  // ---------------------------------------------------------------- Consent
  function consentStand() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return null; // API noch nicht da
      return !!cp.analyticsProcessingAllowed();
    } catch (e) { return null; }
  }

  // ---------------------------------------------------------------- Messung
  var variante = 'a', sid = null, aktiv = false, start = Date.now();
  function melde(ereignis, extra) {
    if (!aktiv) return;
    var p = { t: cfg.test, v: variante, e: ereignis, s: sid, h: handle, m: hatModul, g: geraet };
    if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) p[k] = extra[k];
    try {
      var body = JSON.stringify(p);
      if (!(navigator.sendBeacon && navigator.sendBeacon(cfg.beacon, body))) {
        fetch(cfg.beacon, { method: 'POST', body: body, keepalive: true, mode: 'cors', headers: { 'Content-Type': 'text/plain;charset=UTF-8' } }).catch(function () {});
      }
    } catch (e) {}
    try {
      if (window.clarity) {
        window.clarity('set', 'hs_variante', variante);
        window.clarity('set', 'hs_modul', hatModul ? 'ja' : 'nein');
        if (extra && extra.z) window.clarity('set', 'hs_ziel', extra.z);
        window.clarity('event', 'hs_' + ereignis);
      }
    } catch (e) {}
    try {
      if (window.gtag) window.gtag('event', 'hs_' + ereignis, Object.assign({ hs_variante: variante, hs_quelle: handle, hs_modul: hatModul ? 'ja' : 'nein' }, extra || {}));
    } catch (e) {}
  }

  function zuweisen() {
    if (cfg.modus === 'alle') return 'b';
    if (cfg.modus !== 'test') return 'a';
    // ?hs=a|b erzwingt eine Variante (Vorschau/Abnahme) und macht sie sticky.
    var erzwungen = (location.search.match(/[?&]hs=(a|b)\b/) || [])[1];
    if (erzwungen) { ls('architare_hs_variante', erzwungen); ls('architare_hs_test', cfg.test); return erzwungen; }
    var v = ls('architare_hs_variante');
    if ((v !== 'a' && v !== 'b') || ls('architare_hs_test') !== cfg.test) {
      v = Math.random() < (cfg.split || 0.5) ? 'b' : 'a';
      ls('architare_hs_variante', v); ls('architare_hs_test', cfg.test);
    }
    return v;
  }

  var gestartet = false;
  function starten() {
    if (gestartet) return;
    gestartet = true;
    if (cfg.modus === 'aus') return;
    var consent = consentStand();
    if (cfg.modus === 'test' && consent !== true) return; // ohne Consent: Variante a, nichts speichern
    variante = zuweisen();
    if (variante === 'b' && hatModul) document.documentElement.classList.add('hs-b');
    // Vorschau-Browser zaehlen NIE mit: wer einmal ?hs=a|b benutzt hat (Anton, Buero,
    // Abnahme), traegt fuer diesen Test eine dauerhafte Vorschau-Markierung — Variante
    // wird gezeigt, aber kein Beacon, kein Cart-Attribut. Fund 28.08.: die ersten
    // Live-Events waren unser eigenes Ausprobieren.
    if (/[?&]hs=(a|b)\b/.test(location.search)) ls('architare_hs_vorschau', cfg.test);
    if (ls('architare_hs_vorschau') === cfg.test) return;
    if (consent === true) {
      sid = ss('architare_hs_sid');
      if (!sid || !/^[a-f0-9]{16}$/.test(sid)) { sid = hex16(); ss('architare_hs_sid', sid); }
      aktiv = true;
      melde('pdp');
      // Umsatz-Zuordnung ohne Bezahl-App: sobald die Sitzung etwas in den Warenkorb
      // legt, traegt der Warenkorb die Test-Variante als Attribut — das landet auf der
      // Bestellung (Shopify Admin: Zusaetzliche Details) und macht Umsatz je Gruppe
      // spaeter auswertbar. Nur Test-Kennung, keine Personendaten; einmal je Sitzung.
      function markiereWarenkorb() {
        if (ss('architare_hs_cart_markiert') === cfg.test) return;
        ss('architare_hs_cart_markiert', cfg.test);
        try {
          fetch((cfg.cart || '/cart') + '/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ attributes: { hs_test: cfg.test, hs_variante: variante } })
          }).catch(function () {});
        } catch (e) {}
      }
      document.addEventListener('cart:change', function (ev) {
        var d = ev && ev.detail;
        if (d && d.baseEvent === 'variant:add') {
          markiereWarenkorb();
          if (!d.__hs) melde('atc', { q: 'form' });
        }
      });
      var dauerGemeldet = false;
      function dauer() {
        if (dauerGemeldet) return; dauerGemeldet = true;
        melde('dauer', { w: Math.round((Date.now() - start) / 1000) });
      }
      window.addEventListener('pagehide', dauer);
      document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') dauer(); });
    }
  }

  // Consent-API laedt asynchron; in JEDEM Modus auf sie warten (Fund 28.08.: im
  // kontrolle/alle-Modus startete das Skript sofort — wiederkehrende Besucher mit
  // gespeicherter Zustimmung bekommen kein visitorConsentCollected-Event und wurden
  // dadurch nie gezaehlt). Danach reagiert der Listener auf spaetere Zustimmung.
  (function warte(n) {
    if (consentStand() !== null || n <= 0) { starten(); return; }
    setTimeout(function () { warte(n - 1); }, 250);
  })(16);
  document.addEventListener('visitorConsentCollected', function () {
    if (!aktiv && consentStand() === true) { gestartet = false; starten(); }
  });

  if (!hatModul) return;

  // ---------------------------------------------------------------- Signet im Trigger
  var FARBEN = ['#C9B896', '#C08A2E', '#B4552F', '#77876B', '#7A6A82'];
  (function signet() {
    var c = root.querySelector('[data-hs-signet]');
    if (!c || !c.getContext) return;
    var x = c.getContext('2d'), laufend = false;
    var P = [];
    for (var i = 0; i < 16; i++) P.push({ w: i / 16 * 6.283, r: 11 + (i % 3) * 9, ph: Math.random() * 6.28, f: FARBEN[i % FARBEN.length] });
    function tick(t) {
      if (!laufend) return;
      x.clearRect(0, 0, 84, 84);
      for (var i = 0; i < P.length; i++) {
        var p = P[i], w = p.w + t * 0.0006, puls = 1 + Math.sin(t * 0.0022 + p.ph) * 0.4;
        x.beginPath(); x.arc(42 + Math.cos(w) * p.r, 42 + Math.sin(w) * p.r * 0.9, 1.9 * puls, 0, 6.283);
        x.fillStyle = p.f; x.fill();
      }
      x.beginPath(); x.arc(42, 42, 3.4 + Math.sin(t * 0.0018) * 0.8, 0, 6.283); x.fillStyle = '#C08A2E'; x.fill();
      requestAnimationFrame(tick);
    }
    function an() { if (!laufend) { laufend = true; requestAnimationFrame(tick); } }
    function aus() { laufend = false; }
    if (ruhig) { laufend = true; tick(0); laufend = false; return; }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { e.isIntersecting ? an() : aus(); }); }).observe(c);
    } else an();
  })();

  // ---------------------------------------------------------------- Inline-Buehne
  var tpl = root.querySelector('[data-hs-buehne]');
  // Anker-Bild vorladen, sobald der Trigger im Blick ist — sonst steht im ersten
  // Akt ein weisser Kasten, wo das Produkt sein soll (Fund 26.08. im Staging).
  (function lade() {
    try {
      var img = tpl && tpl.content.querySelector('[data-hs-anker] img');
      if (!img) return;
      var los = root.querySelector('[data-hs-los]');
      function vor() { var i = new Image(); i.src = img.getAttribute('src'); }
      if ('IntersectionObserver' in window && los) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { vor(); io.disconnect(); } });
        });
        io.observe(los);
      } else vor();
    } catch (e) {}
  })();
  var sektion = root.closest('.shopify-section') || root.closest('section') || document.body;
  var buehne = null, feld, fx, laeuft = false, startZeit = 0, teilchen = [], karten = [], timer = [];
  var altPos = '', altMinH = '';

  function nach(ms, fn) { timer.push(setTimeout(fn, ruhig ? Math.min(ms, 150) : ms)); }
  function d() { return window.devicePixelRatio || 1; }
  function mass() {
    // Canvas deckt den sichtbaren Kopf der Buehne ab, nicht die ganze (u. U. sehr hohe) Sektion
    var w = buehne.clientWidth, h = Math.min(buehne.clientHeight, Math.max(window.innerHeight * 1.15, 760));
    feld.width = w * d(); feld.height = h * d();
    feld.style.width = w + 'px'; feld.style.height = h + 'px';
  }
  function relXY(el) {
    var r = el.getBoundingClientRect(), b = buehne.getBoundingClientRect();
    return { x: (r.left - b.left + r.width / 2) * d(), y: (r.top - b.top + r.height / 2) * d() };
  }
  function wirbelXY() {
    var rechts = buehne.querySelector('[data-hs-rechts]');
    var p = relXY(rechts);
    var r = rechts.getBoundingClientRect();
    return { x: p.x, y: p.y, rad: Math.min(r.width, r.height, 620) * 0.42 * d() };
  }
  function zeichne(t) {
    if (!laeuft) return;
    var dp = d(), q = relXY(buehne.querySelector('[data-hs-anker]'));
    var alter = (t - startZeit) / 1000;
    fx.clearRect(0, 0, feld.width, feld.height);
    var phase = ruhig ? 3 : (alter < 1.4 ? 1 : alter < 2.5 ? 2 : 3);
    for (var i = 0; i < teilchen.length; i++) {
      var p = teilchen[i], zx, zy;
      if (phase === 1) {
        var wz = wirbelXY(), w = p.ph + t * 0.0007 * p.tempo;
        zx = wz.x + Math.cos(w) * p.orbit * wz.rad; zy = wz.y + Math.sin(w) * p.orbit * wz.rad * 0.78;
      } else {
        var z = relXY(karten[p.ziel]), w2 = p.ph + t * 0.0008 * p.tempo;
        var r = (phase === 2 ? Math.max(6, 44 - (alter - 1.4) * 34) : 10 + Math.sin(t * 0.0012 + p.ph) * 5) * dp;
        zx = z.x + Math.cos(w2) * r; zy = z.y + Math.sin(w2) * r;
      }
      p.x += (zx - p.x) * (phase === 2 ? 0.07 : 0.045); p.y += (zy - p.y) * (phase === 2 ? 0.07 : 0.045);
      fx.beginPath(); fx.arc(p.x, p.y, p.gr, 0, 6.283);
      fx.fillStyle = p.f; fx.globalAlpha = phase === 3 ? 0.4 : 0.85; fx.fill(); fx.globalAlpha = 1;
    }
    if (phase >= 2) {
      for (var j = 0; j < karten.length; j++) {
        var zj = relXY(karten[j]);
        var g = fx.createLinearGradient(q.x, q.y, zj.x, zj.y);
        g.addColorStop(0, 'rgba(192,138,46,.5)'); g.addColorStop(1, 'rgba(201,184,150,.12)');
        fx.strokeStyle = g; fx.lineWidth = 1 * dp;
        fx.beginPath(); fx.moveTo(q.x, q.y); fx.lineTo(zj.x, zj.y); fx.stroke();
      }
    } else {
      for (var k = 0; k < teilchen.length; k += 7) {
        var a = teilchen[k], b = teilchen[(k + 13) % teilchen.length], dist = Math.hypot(a.x - b.x, a.y - b.y);
        if (dist < 110 * dp) { fx.strokeStyle = 'rgba(201,184,150,' + ((1 - dist / (110 * dp)) * 0.25) + ')'; fx.lineWidth = 0.7 * dp; fx.beginPath(); fx.moveTo(a.x, a.y); fx.lineTo(b.x, b.y); fx.stroke(); }
      }
    }
    requestAnimationFrame(zeichne);
  }
  function onResize() { if (laeuft) mass(); }

  function oeffne() {
    if (buehne || !tpl) return;
    var frag = tpl.content.cloneNode(true);
    buehne = frag.querySelector('.hs-buehne');
    altPos = sektion.style.position; altMinH = sektion.style.minHeight;
    if (getComputedStyle(sektion).position === 'static') sektion.style.position = 'relative';
    sektion.appendChild(buehne);
    // Sektion mindestens so hoch wie der Buehnen-Inhalt, sonst wird unten abgeschnitten
    var inhalt = buehne.querySelector('.hs-buehne__inhalt');
    feld = buehne.querySelector('[data-hs-feld]'); fx = feld.getContext('2d');
    karten = Array.prototype.slice.call(buehne.querySelectorAll('[data-hs-karte]'));
    var statusEl = buehne.querySelector('[data-hs-status]');
    var STATUS = [statusEl.getAttribute('data-hs-s1'), statusEl.getAttribute('data-hs-s2'), statusEl.getAttribute('data-hs-s3')];
    window.addEventListener('resize', onResize);

    // Zum Kopf der Sektion scrollen, dort spielt die Inszenierung
    try { sektion.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'start' }); } catch (e) { sektion.scrollIntoView(); }

    requestAnimationFrame(function () {
      if (inhalt.offsetHeight + 40 > sektion.offsetHeight) sektion.style.minHeight = (inhalt.offsetHeight + 60) + 'px';
      buehne.classList.add('an');
      laeuft = true; startZeit = performance.now();
      mass();
      // Teilchen entstehen im Anker (Produktbild) und schwaermen nach rechts
      var q = relXY(buehne.querySelector('[data-hs-anker]'));
      teilchen = [];
      for (var i = 0; i < 190; i++) {
        teilchen.push({
          x: q.x + (Math.random() - 0.5) * 50, y: q.y + (Math.random() - 0.5) * 50,
          f: FARBEN[Math.random() * FARBEN.length | 0], gr: (0.9 + Math.random() * 1.8) * d(),
          ph: Math.random() * 6.283, tempo: 0.5 + Math.random() * 0.9,
          ziel: Math.random() * karten.length | 0, orbit: 0.15 + Math.random() * 0.85
        });
      }
      requestAnimationFrame(zeichne);
    });

    nach(250, function () { buehne.querySelector('[data-hs-titel]').classList.add('da'); });
    nach(420, function () { buehne.querySelector('[data-hs-zlabel]').classList.add('da'); });
    STATUS.forEach(function (s, i) { nach(500 + i * 760, function () { statusEl.textContent = s; statusEl.classList.add('da'); }); });
    nach(2450, function () { statusEl.classList.remove('da'); });
    nach(2600, function () {
      karten.forEach(function (k, i) { nach(160 * i, function () { k.classList.add('da'); }); });
      nach(160 * karten.length + 200, function () { buehne.querySelector('[data-hs-aktion]').classList.add('da'); });
      melde('hs_karten', { p: karten.length });
    });
    karten.forEach(function (k) {
      k.addEventListener('click', function () {
        melde('hs_ziel', { z: k.getAttribute('data-hs-handle'), r: k.getAttribute('data-hs-rolle'), p: Number(k.getAttribute('data-hs-position')) });
      });
    });
    buehne.querySelector('[data-hs-zu]').addEventListener('click', schliesse);
    buehne.querySelector('[data-hs-mitnehmen]').addEventListener('click', mitnehmen);
  }
  function schliesse() {
    laeuft = false; timer.forEach(clearTimeout); timer = [];
    window.removeEventListener('resize', onResize);
    if (buehne) {
      var b = buehne; b.classList.remove('an');
      setTimeout(function () {
        if (b.parentNode) b.parentNode.removeChild(b);
        sektion.style.position = altPos; sektion.style.minHeight = altMinH;
      }, 650);
    }
    buehne = null; karten = [];
  }
  function mitnehmen() {
    // Einzeln statt als Liste: Shopify lehnt eine Sammel-Anfrage komplett ab, sobald EIN
    // Produkt nicht per add.js geht (Fund 26.08.: Bundle "Liz Wood Komplettset" → 422).
    // Danach die Warenkorb-Seite — sie zeigt verlaesslich, was gelandet ist.
    var btn = buehne && buehne.querySelector('[data-hs-mitnehmen]');
    if (!btn || btn.disabled) return;
    var items = karten.map(function (k) { return Number(k.getAttribute('data-hs-variante-id')); }).filter(function (id) { return id > 0; });
    if (!items.length) return;
    btn.disabled = true; btn.textContent = cfg.lauf || btn.textContent;
    melde('hs_mitnehmen', { p: items.length });
    var gelandet = 0;
    items.reduce(function (kette, id) {
      return kette.then(function () {
        return fetch(cfg.add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ id: id, quantity: 1 }) })
          .then(function (r) { if (r.ok) gelandet++; }).catch(function () {});
      });
    }, Promise.resolve()).then(function () {
      if (gelandet > 0) melde('atc', { q: 'hs', p: gelandet });
      if (!aktiv) return null; // ohne Consent keine Test-Markierung — gleiche Grenze wie die Messung
      return fetch((cfg.cart || '/cart') + '/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ attributes: { hs_test: cfg.test, hs_variante: variante } })
      }).catch(function () {});
    }).then(function () {
      window.location.href = cfg.cart || '/cart';
    });
  }

  root.querySelector('[data-hs-los]').addEventListener('click', function () { melde('hs_klick'); oeffne(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && buehne) schliesse(); });
})();
